import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxDateBoxComponent,
  DxLoadPanelComponent,
  DxNumberBoxComponent,
  DxPopupComponent,
  DxTemplateDirective,
  DxTextAreaComponent,
  DxTextBoxComponent,
  DxValidationGroupComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoSelectionComponent,
} from 'devextreme-angular/ui/nested';
import { alert, confirm } from 'devextreme/ui/dialog';
import moment from 'moment';
import { RUOLO_OPERATORE_BASE } from 'src/app/consts/const';
import { Articoli, ArticoliReqModel } from 'src/app/models/articoli';
import { ArticoliConsegnaModel } from 'src/app/models/articoli-consegna-model';
import { ArticoliMatricola } from 'src/app/models/articoli-matricola';
import { DettaglioMovimento } from 'src/app/models/dettaglio-movimento';
import { Dipendente } from 'src/app/models/dipendente';
import { KitArticoli } from 'src/app/models/kit-articolo';
import {
  MovimentoArticoloModel,
  TipoGestioneGiornaliera,
} from 'src/app/models/movimento-articolo';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { PopupSceltaDipendenteComponent } from 'src/app/shared/components/popups/popup-scelta-dipendente/popup-scelta-dipendente.component';
import { PopupSceltaMatricolaComponent } from 'src/app/shared/components/popups/popup-scelta-matricola/popup-scelta-matricola.component';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { KitArticoliService } from 'src/app/shared/services/kit-articoli.service';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-restituzione-guidata',
  templateUrl: './restituzione-guidata.component.html',
  styleUrls: ['./restituzione-guidata.component.scss'],
  imports: [
    DxButtonComponent,
    DxTextBoxComponent,
    DxiValidationRuleComponent,
    DxValidationGroupComponent,
    DxValidatorComponent,
    DxDateBoxComponent,
    DxLoadPanelComponent,
    DxDataGridComponent,
    DxoEditingComponent,
    DxiColumnComponent,
    DxTemplateDirective,
    DxPopupComponent,
    DxTextAreaComponent,
    PopupSceltaDipendenteComponent,
    DxNumberBoxComponent,
    DxoSelectionComponent,
    PopupSceltaMatricolaComponent,
  ],
})
export class RestituzioneGuidataComponent implements OnInit {
  @ViewChild('gridRestituzioni', { static: false })
  gridRestituzioni!: DxDataGridComponent;
  @ViewChild('barcodeArticolo', { static: false })
  barcodeArticoloTxtBox!: DxTextBoxComponent;
  @ViewChild('barcodeDipendente', { static: false })
  barcodeDipendenteTxtBox!: DxTextBoxComponent;
  @ViewChild('barcodeMatricola', { static: false })
  barcodeMatricola!: DxTextBoxComponent;
  private storageService = inject(StorageService);
  private navigatorService = inject(NavigatorService);
  private dipendentiService = inject(DipendentiService);
  private tipiArticoliService = inject(TipiArticoliService);
  private articoliService = inject(ArticoliService);
  private articoliMatricolaService = inject(ArticoliMatricolaService);
  private movimentiArticoliService = inject(MovimentoArticoliService);
  private kitArticoliService = inject(KitArticoliService);

    private lastInsertTime = Date.now();


  isBase: boolean = true;
  visibleLoadPanel: boolean = false;

  idDipendente: number;
  codiceDipendente: string;
  codiceArticolo: string;

  dataRestituzione: Date;
  dataConsegna: Date;

  listDipendenti: Dipendente[];
  listTipiArticoli: TipiArticoli[];
  listArticoli: ArticoliConsegnaModel[];
  listMatricole: ArticoliMatricola[];

  popupNota: boolean = false;
  nota: string;
  rigaSelezionata: Articoli;
  sezioneArticolo: boolean = false;
  dipendenteInserito: boolean = false;
  popupSceltaDipendente: boolean = false;
  dipendente: string;
  buttonDipendente: boolean = true;
  listKitArticoli: KitArticoli[];
  sceltaMatricola: boolean = false;
  idsMatricoleDisponibili: number[];
  listMatricoleDisponibiliFiltrate: ArticoliMatricola[];
  popupSceltaMatricola: boolean = false;
  matricolaArticolo: string;
  idArticoloSceltaMatricola: number;
  altezzaPopupNota: number = 300;

  ngOnInit(): void {
    this.loadLookUp();
    this.dataConsegna = new Date();
    this.dataRestituzione = new Date();
    this.isBase =
      this.storageService.utenteCorrente.ruoloString == RUOLO_OPERATORE_BASE;
      if(this.isMax1600()){
        this.altezzaPopupNota = 320;
      }
  }

  onBarcodeDipendenteTxtBoxInitialized(e) {
    e.component.focus();
  }
  onBarcodeArticoloTxtBoxInitialized(e) {
    e.component.focus();
  }

  loadLookUp() {
    //List Dipendenti
    this.dipendentiService.listTemp().subscribe({
      next: (res) => {
        this.listDipendenti = res.filter(x => x.attivo);
      }
    });

    //List TipiArticoli
    this.tipiArticoliService.list().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore recupero lista tipi articoli', 'error');
        }
      },
    });

    //List ArticoliMatricola
    this.articoliMatricolaService.list().subscribe({
      next: (res) => {
        this.listMatricole = res;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio(
            'Errore recupero lista matricole articoli',
            'error',
          );
        }
      },
    });

    //List KitArticoli
    this.kitArticoliService.list().subscribe({
      next: (res) => {
        this.listKitArticoli = res;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore recupero kit articoli', 'error');
        }
      },
    });
  }

  loadConsegnePreviste() {
    this.visibleLoadPanel = true;
    const request: ArticoliReqModel = {
      idDipendente: this.idDipendente,
      dataMovimento: this.dataConsegna,
    };
    this.articoliService.consegnePrevisteGiornaliere(request).subscribe({
      next: (res) => {
        this.visibleLoadPanel = false;
        this.listArticoli = res.map((item) => ({
          ...item,
          quantitaRestituita: 0,
        }));
        //Prendo le matricole disponibili per la restituzione
        this.idsMatricoleDisponibili = this.listArticoli
          .filter((x) => x.idMatricola != undefined)
          .map((x) => x.idMatricola);
        //Strutturo la lista per la visualizzazione in tabella
        let struttura: Articoli[] = [];
        this.listArticoli.forEach(element => {
          if(element.gestioneKit){
            const kitOriginale = {...element};
            kitOriginale.dataInserimento = this.getDataInserimento();
            struttura.push(kitOriginale);
            const qtaKit = element.quantita;
            element.quantita = 0; //Azzero la quantità. Non mi serve più
            const kitComponenti = this.listKitArticoli.filter(x => x.idArticolo == element.id);
            kitComponenti.forEach((comp) => {
              const artOriginale = this.listArticoli.find(
                (x) => x.id == comp.idArticoloComponente,
              );
              const art = {...artOriginale}; //Faccio una copia per non modificare i valori
              const qtaPrevista = comp.quantita * qtaKit;
              if(qtaPrevista > art.quantita){
                art.quantita = art.quantita;
              }
              else{
                art.quantita = qtaPrevista;
              }
              art.quantitaRestituita = 0;
              art.componenteFiglio = true;
              art.dataInserimento = this.getDataInserimento();
              struttura.push(art);
              artOriginale.quantita -= art.quantita;
            });
          }
        });
        this.listArticoli.forEach(element => {
          if(element.quantita != 0){
            element.dataInserimento = this.getDataInserimento();
            struttura.push(element);
          }
        });
        this.listArticoli = struttura;
      },
      error: (err) => {
        this.visibleLoadPanel = false;
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore recupero movimenti', 'error');
        }
      },
    });
  }

  getDataInserimento(): Date {
    this.lastInsertTime += 1001;
    return new Date(this.lastInsertTime);
  }

  onSelectionChanged(e: any) {
    this.rigaSelezionata = e.selectedRowsData[0];

    if (!this.rigaSelezionata) {
      return;
    }
  }

  cercaConsegne() {
    if (this.idDipendente == undefined) {
      notificaMessaggio('Selezionare il dipendente', 'warning');
      return;
    }
    this.loadConsegnePreviste();
  }

  ripulisciDati() {
    this.idDipendente = 0;
    this.codiceDipendente = undefined;
    this.codiceArticolo = undefined;
    this.listArticoli = [];
    this.buttonDipendente = true;
    this.sezioneArticolo = false;
    this.dipendenteInserito = false;
    setTimeout(() => {
      this.barcodeDipendenteTxtBox.instance.focus();
    }, 50);
    this.rigaSelezionata = undefined;
  }

  onCodiceDipendenteChanged() {
    let dip = this.listDipendenti.find(
      (x) => x.codice == this.codiceDipendente,
    );
    if (dip != undefined) {
      this.idDipendente = dip.id;
      this.loadConsegnePreviste();
      this.sezioneArticolo = true;
      this.dipendenteInserito = true;
      this.buttonDipendente = false;
    } else {
      notificaMessaggio(
        'Dipendente non attivo o codice dipendente errato',
        'warning',
      );
      return;
    }
  }

  onBarcodeArticolo() {
    const barcode: string = this.codiceArticolo;
    if (barcode.includes('_')) {
      //Siamo nel caso con matricola
      const codiceArticoloEMatricola: string[] = barcode.split('_');
      const codiceArticolo: string = codiceArticoloEMatricola[0];
      const matricola: string = codiceArticoloEMatricola[1];

      const matricolaFind = this.listMatricole.find(
        (x) => x.matricola == matricola,
      );
      if (matricola == undefined) {
        notificaMessaggio('Matricola non trovata', 'warning');
      }

      const index = this.listArticoli.findIndex(
        (x) => x.codice == codiceArticolo && x.idMatricola == matricolaFind.id,
      );
      if (index >= 0) {
        if (
          this.listArticoli[index].quantitaRestituita ==
          this.listArticoli[index].quantita
        ) {
          return;
        }
        this.listArticoli[index].quantitaRestituita++;
        this.rigaSelezionata = this.listArticoli[index];
        setTimeout(() => {
          this.gridRestituzioni.instance.selectRows(
            [this.listArticoli[index]],
            false,
          );
          this.gridRestituzioni.instance.option(
            'focusedRowKey',
            this.listArticoli[index],
          );
        }, 50);
      } else {
        notificaMessaggio(
          'Codice articolo_matricola non presente nelle restituzioni previste',
          'warning',
        );
      }
    } else {
      const codiceArticolo = this.codiceArticolo;
      const index = this.listArticoli.findIndex(
        (x) => x.codice == codiceArticolo,
      );
      //verifico se è un articolo con matricola
      const articolo = this.listArticoli[index];
      if (this.listMatricole.some((x) => x.idArticolo == articolo.id)) {
        this.sceltaMatricola = true;
        setTimeout(() => {
          this.barcodeMatricola.instance.focus();
        }, 50);
        this.idArticoloSceltaMatricola = articolo.id;
        return;
      }
      //Siamo nel caso senza matricola

      if (index >= 0) {
        if (
          this.listArticoli[index].quantitaRestituita ==
          this.listArticoli[index].quantita
        ) {
          return;
        }
        const articolo = this.listArticoli[index];
        if(articolo.gestioneKit){
          var componenti = this.listKitArticoli.filter(x => x.idArticolo == articolo.id);
          componenti.forEach(comp => {
            const componente = this.listArticoli.find(x => x.id == comp.idArticoloComponente && x.componenteFiglio);
            componente.quantitaRestituita += comp.quantita;
            if(componente.quantitaRestituita> componente.quantita){ //Caso in cui ha definito un kit e poi ha tolto articoli dal kit
              componente.quantitaRestituita = componente.quantita;
            }
          });
        }
        this.listArticoli[index].quantitaRestituita++;
        this.rigaSelezionata = this.listArticoli[index];
        setTimeout(() => {
          this.gridRestituzioni.instance.selectRows(
            [this.listArticoli[index]],
            false,
          );
          this.gridRestituzioni.instance.option(
            'focusedRowKey',
            this.listArticoli[index],
          );
        }, 50);
      } else {
        notificaMessaggio(
          'Codice articolo non presente nelle restituzioni previste',
          'warning',
        );
      }
    }
  }

  onDipendenteCerca() {
    this.popupSceltaDipendente = true;
  }
  onIdDipendenteEventEmitter(e: any) {
    if (e == null) {
      this.popupSceltaDipendente = false;
      return;
    }
    let dip = this.listDipendenti.find((x) => x.id == e);
    if (dip != undefined) {
      this.idDipendente = dip.id;
      this.dipendente = dip.codice + '-' + dip.nominativo;
      this.sezioneArticolo = true;

      this.codiceDipendente = '';
      this.dipendenteInserito = true;
      this.buttonDipendente = false;
      this.popupSceltaDipendente = false;
      this.loadConsegnePreviste();
    } else {
      notificaMessaggio(
        'Dipendente non attivo o codice dipendente errato',
        'warning',
      );
      this.codiceDipendente = '';
      this.popupSceltaDipendente = false;
      return;
    }
  }

  getArticoloDisplayExpr(item) {
    if (!item) {
      return '';
    }
    return (
      item.codice +
      (item.taglia ? ' - ' + item.taglia : '') +
      ' - ' +
      item.descrizione
    );
  }

  getDescrizione() {
    const tipo = this.listTipiArticoli.find(
      (x) => x.id == this.rigaSelezionata.idTipo,
    );
    return (
      tipo.descrizione + ' ' + this.getArticoloDisplay(this.rigaSelezionata)
    );
  }

  getArticoloDisplay(articolo: Articoli): string {
    if (!articolo) {
      return '';
    }
    let s =
      articolo.codice +
      (articolo.taglia ? ' - ' + articolo.taglia : '') +
      ' - ' +
      articolo.descrizione;
    if (articolo.idMatricola) {
      s += ` (${this.listMatricole.find((x) => x.id == articolo.idMatricola).matricola})`;
    } else if (this.listMatricole?.some((x) => x.idArticolo === articolo.id)) {
      s += ' (matricola da scegliere)';
    }
    return s;
  }

  segnaConsegnato(articolo: Articoli) {
    let index = this.listArticoli.findIndex((x) => x.id == articolo.id);
    if (
      this.listArticoli[index].quantitaRestituita ==
      this.listArticoli[index].quantita
    ) {
      return;
    }
    this.listArticoli[index].quantitaRestituita++;
  }

  effettuaResituzione(e) {
    if (this.listArticoli == undefined || this.listArticoli.length == 0) {
      notificaMessaggio('Non sono presenti articoli da restituire', 'warning');
      return;
    }
    if(this.listArticoli.every(x => x.quantitaRestituita == 0)){
      notificaMessaggio('Quantità da restituire impostate tutte a zero', 'warning');
      return;
    }
    const nuovoMovimento = new MovimentoArticoloModel();
    nuovoMovimento.listDettaglio = [];

    const result = confirm(
      '<i>Restituire gli articoli?</i>',
      'Restituzione Articoli',
    );
    result.then((dialogResult) => {
      if (dialogResult) {
        if (!this.tuttiConsegnati()) {
          const secondResult = confirm(
            '<i>Non tutti gli articoli risulta consegnati, vuoi continuare?</i>',
            'Articoli Mancanti',
          );
          secondResult.then((dialogResult) => {
            if (dialogResult) {
              this.popupNota = true;
              this.nota = undefined;
            }
          });
        } else {
          const movimento = this.generaMovimento(this.listArticoli);
          this.sendMovimento(movimento);
        }
      }
    });
  }

  onPopupOk() {
    if (this.nota == undefined || !this.nota.trim()) {
      notificaMessaggio('Inserire una nota valida', 'warning');
      return;
    }
    this.popupNota = false;

    //Calibro la quantità come scelta dall'utente
    const articoli = this.listArticoli.map((x) => ({
      ...x,
      quantita: x.quantitaRestituita,
    }));

    //Prendo solo gli articoli che non sono con quanittà = 0
    const articoliEffettivi = articoli.filter((x) => x.quantita != 0);
    if (articoliEffettivi.length == 0) {
      notificaMessaggio('Nessun articolo restituito', 'error');
      this.popupNota = false;
      return;
    }
    const movimento = this.generaMovimento(articoliEffettivi);
    movimento.dettagli = this.nota;
    this.sendMovimento(movimento);
  }

  tuttiConsegnati() {
    return this.listArticoli.every((x) => x.quantitaRestituita == x.quantita);
  }

  effettuaResituzioneCompleta() {
    if (this.listArticoli == undefined || this.listArticoli.length == 0) {
      notificaMessaggio('Non sono presenti articoli da restituire', 'warning');
      return;
    }
    const result = confirm(
      '<i>Restituire tutti gli articoli?</i>',
      'Restituzione completa',
    );
    result.then((dialogResult) => {
      if (dialogResult) {
        const nuovoMovimento = this.generaMovimento(this.listArticoli);
        this.sendMovimento(nuovoMovimento);
      }
    });
  }

  generaMovimento(articoli: Articoli[]) {
    const nuovoMovimento = new MovimentoArticoloModel();
    nuovoMovimento.listDettaglio = [];
    nuovoMovimento.data = moment(this.dataRestituzione).utc(true).toDate();
    nuovoMovimento.idDipendente = this.idDipendente;
    nuovoMovimento.gestioneGiornaliera =
      TipoGestioneGiornaliera.restituzioneGiornaliera;
    articoli.forEach((articolo) => {
      const temp = new DettaglioMovimento();
      temp.idArticolo = articolo.id;
      temp.idTipoArticolo = articolo.idTipo;
      temp.qta = articolo.quantita;
      temp.cambio = false;
      temp.usaMatricola = this.listTipiArticoli.find(
        (x) => x.id == articolo.idTipo,
      ).usaMatricola;
      if (temp.usaMatricola) {
        temp.listMatricoleRitiro = [];
        const articoloMatricola = this.listMatricole.find(
          (x) => x.idArticolo == articolo.id,
        );
        const newAssegnazione = new ArticoliMatricola();
        newAssegnazione.id = articoloMatricola.id;
        newAssegnazione.idArticolo = articoloMatricola.idArticolo;
        newAssegnazione.matricola = articoloMatricola.matricola;
        temp.listMatricoleRitiro.push(newAssegnazione);
      }
      nuovoMovimento.listDettaglio.push(temp);
    });
    return nuovoMovimento;
  }

  sendMovimento(movimento: MovimentoArticoloModel) {
    this.movimentiArticoliService.insertGiornaliera(movimento).subscribe({
      next: (res) => {
        this.visibleLoadPanel = false;
        if (res.result) {
          if (res.errori != null && res.errori.length > 0) {
            this.mostraAlertResult(
              res.errori,
              'Movimento inserito con avvisi:',
            );
          } else {
            notificaMessaggio('Movimento inserito', 'success');
            this.ripulisciDati();
            this.navigatorService.goToDocMovimento(res.newMovimento.progr, false);
          }
        } else {
          if (res.errori != null && res.errori.length > 0) {
            this.mostraAlertResult(res.errori, 'Movimento non inserito');
          }
          notificaMessaggio('Errore inserimento movimento', 'warning');
        }
      },
      error: (err) => {
        this.visibleLoadPanel = false;
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio(
            "Qualcosa è andato storto con l'inserimento del movimento",
            'error',
          );
        }
      },
    });
  }

  mostraAlertResult(errori: string[], title: string) {
    let strErroriHtml = '<ul>';
    errori.forEach((element) => {
      strErroriHtml += '<li>' + element + '</li>';
    });
    strErroriHtml += '</ul>';
    alert(strErroriHtml, title);
  }

  esci() {
    this.navigatorService.goToDashboardGiornaliera();
  }
  isMax1600(): boolean {
    return window.matchMedia('(max-width: 1600px)').matches;
  }

  onQtaChanged(e, rowData: Articoli) {
    const articoloKit = this.listKitArticoli.filter(
      (x) => x.idArticolo == rowData.id,
    );
    if (articoloKit.length != 0) {
      const idsComponenti = articoloKit.map((x) => x.idArticoloComponente);
      let listComponenti = this.listArticoli.filter((x) =>
        idsComponenti.includes(x.id),
      );
      listComponenti.forEach((comp) => {
        const moltiplicatore = e.value - e.previousValue;
        comp.quantitaRestituita +=
          moltiplicatore *
          articoloKit.find((x) => x.idArticoloComponente == comp.id).quantita;
      });
    }
    rowData.quantitaRestituita = e.value;
  }

  onRowPrepared(e: any) {
    if (e.rowType === 'data' && e.data?.componenteFiglio && !e.data?.kit) {
      e.rowElement.style.backgroundColor = '#f0eeee';
    }
  }

  rowUpdated(e) {
    const rowData = e.data;
    const articolo = this.listArticoli.find((x) => x.id == rowData.idArticolo);
    if (articolo.gestioneKit) {
      const articoliComponenti = this.listKitArticoli.filter(
        (x) => x.idArticolo == articolo.id,
      );
      articoliComponenti.forEach((articoloComp) => {
        const index = this.listArticoli.findIndex(
          (x) => x.id == articoloComp.idArticoloComponente,
        );
        this.listArticoli[index].quantitaRestituita =
          rowData.qta * articoloComp.quantita;
      });
    }
  }

  onEditorPreparing(e: any) {
    if (
      e.parentType === 'dataRow' &&
      (e.dataField === 'idTipoArticolo' || e.dataField === 'idArticolo')
    ) {
      // editabile SOLO in insert
      e.editorOptions.disabled = !e.row?.isNewRow;
    }
  }

  async onFocusedRowChanged(e) {
    if (!e || !e.row || !e.row.data) {
      return;
    }
    const rowData = e.row.data;
    this.rigaSelezionata = rowData;
    this.idArticoloSceltaMatricola=undefined;
  }

  qtaRestituitaInsufficiente() {
    return (
      this.rigaSelezionata.quantitaRestituita < this.rigaSelezionata.quantita
    );
  }

  onMatricolaCerca() {
    var idArticolo = this.rigaSelezionata.id;
    var matricoleUsate = this.listArticoli
      .filter(
        (x) =>
          x.idMatricola != undefined &&
          x.id == idArticolo &&
          x.quantitaRestituita < x.quantita,
      )
      .map((x) => x.idMatricola);
    this.listMatricoleDisponibiliFiltrate = this.listMatricole.filter(
      (x) => !matricoleUsate.includes(x.id) && x.idArticolo == idArticolo,
    );
    this.popupSceltaMatricola = true;
  }

  onIdMatricolaEventEmitter(e) {
    if (e == null) {
      return;
    }
    const matricola = this.listMatricoleDisponibiliFiltrate.find(
      (x) => x.id == e,
    );
    if (matricola == undefined) {
      notificaMessaggio('Matricola errata o non disponibile', 'warning');
      this.popupSceltaMatricola = false;
      return;
    }
    const articoloDaRestituire = this.listArticoli.find(
      (x) => x.id == this.idArticoloSceltaMatricola && x.idMatricola == e,
    );
    this.gridRestituzioni.instance.selectRows([articoloDaRestituire.chiaveCustom],false);

    if (
      articoloDaRestituire.quantitaRestituita < articoloDaRestituire.quantita
    ) {
      articoloDaRestituire.quantitaRestituita++;
      notificaMessaggio(
        'Aggiunta restituzione per articolo con matricola ' +
          matricola.matricola,
        'success',
      );
    } else {
      notificaMessaggio(
        "Matricola non in uso o errata per l'articolo selezionato",
        'warning',
      );
    }
    this.barcodeArticoloTxtBox.instance.focus();
    this.matricolaArticolo = undefined;
    this.sceltaMatricola = false;
  }

  onMatricolaArticolo() {
    const matricola = this.listMatricole.find(
      (x) => x.matricola == this.matricolaArticolo && x.idArticolo == this.rigaSelezionata.id
    );
    if (matricola == undefined) {
      notificaMessaggio('Matricola errata o non disponibile', 'warning');
      this.matricolaArticolo='';
      return;
    }
    const articoloDaRestituire = this.listArticoli.find(
      (x) => x.id == this.rigaSelezionata.id && x.idMatricola == matricola.id,
    );
    if (
      articoloDaRestituire.quantitaRestituita < articoloDaRestituire.quantita
    ) {
      articoloDaRestituire.quantitaRestituita++;
      notificaMessaggio(
        'Aggiunta restituzione per articolo con matricola ' +
          matricola.matricola,
        'success',
      );
    } else {
      notificaMessaggio(
        "Matricola non in uso o errata per l'articolo selezionato",
        'warning',
      );
    }
    this.barcodeArticoloTxtBox.instance.focus();
    this.matricolaArticolo = undefined;
    this.sceltaMatricola = false;
  }
}
